module.exports = __webpack_public_path__ + "media/mop.10ad99a2.mp3";